import { useEffect, useState } from "react";
import invoiceService from "../../../../services/invoicesService";
import { useSelector } from "react-redux";
import {
    Backdrop,
    Box,
    CircularProgress,
    Pagination,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Button,
    Modal,
    TextField,
    Stack,
    IconButton
} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { toast } from 'react-toastify';

const InvoiceCustomer = () => {
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1); 
    const [totalPages, setTotalPages] = useState(1);
    const [search, setSearch] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [editingCustomer, setEditingCustomer] = useState({
        id: '',
        name: '',
        mail: '',
        identifier: '',
        taxOffice: '',
        type: 0,
        createDate: '',
        updateDate: '',
        userId: ''
    });

    const authUserId = useSelector(state => state?.auth?.user?.id);

    const getCustomers = async (pageNumber = 1, searchTerm = '') => {
        try {
            setLoading(true);
            const response = await invoiceService.fetchAllInvoicesCustomer({
                userId: authUserId,
                pageNumber: pageNumber,
                search: searchTerm
            });
            setCustomers(response?.data?.data || []);

            const totalCount = response?.data?.recordsTotal;
            const itemsPerPage = 10;
            setTotalPages(Math.ceil(totalCount / itemsPerPage));

            setLoading(false);
        } catch (error) {
            console.error("Error fetching customers:", error);
            setLoading(false);
        }
    };

    const handleSearch = () => {
        setPage(1);
        getCustomers(1, search);
    };

    const handleSearchKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };

    const handlePageChange = (event, value) => {
        setPage(value);
        getCustomers(value, search);
    };

    const handleEditClick = (customer) => {
        setEditingCustomer({
            id: customer.id,
            name: customer.name || '',
            mail: customer.mail || '',
            identifier: customer.identifier || '',
            taxOffice: customer.taxOffice || '',
            type: customer.type || 0,
            createDate: customer.createDate || '',
            updateDate: customer.updateDate || '',
            userId:customer.userId
        });
        setModalOpen(true);
    };

    const handleModalClose = () => {
        setModalOpen(false);
        setEditingCustomer({
            id: '',
            name: '',
            mail: '',
            identifier: '',
            taxOffice: '',
            type: 0,
            createDate: '',
            updateDate: '',
            userId: ''
        });
    };

    const handleInputChange = (field, value) => {
        setEditingCustomer(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSaveCustomer = async () => {
        try {
            setLoading(true);
            if (!editingCustomer.name) {
                alert("İsim alanı boş olamaz.");
                return;
            }
            if (!editingCustomer.mail) {
                alert("Mail alanı boş olamaz.");
                return;
            }

            const response = await invoiceService.updateInvoicesCustomer(editingCustomer);
            if (response?.status == false) {
                toast.error( 'Müşteri güncellenirken bir hata oluştu');
            }
            else{
                toast.success('Müşteri başarıyla güncellendi.');
            }
            await getCustomers(page, search);
            handleModalClose();
        } catch (error) {
         toast.error('Müşteri güncellenirken bir hata oluştu.');
            setLoading(false);
        }
    };

    useEffect(() => {
        getCustomers(page, search);
    }, [authUserId]);

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: { xs: '90%', sm: 500, md: 600 },
        bgcolor: 'background.paper',
        border: 'none',
        borderRadius: 2,
        boxShadow: 24,
        p: 4,
    };

    return (
        <Box>
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <Box
                sx={{
                    padding: { xs: 2, sm: 2.5, md: 3 },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mt: { xs: 2, sm: 3, md: 4 },
                    mb: { xs: 2, sm: 2.5, md: 3 },
                    ml: { xs: 0, sm: 0.5, md: 1 },
                    backgroundColor: "#F7F9FC",
                    borderRadius: { xs: 1, sm: 1.5, md: 2 },
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                }}
            >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                        sx={{
                            width: 4,
                            height: { xs: 20, sm: 24 },
                            backgroundColor: "#1F1B45",
                            mr: 1,
                        }}
                    />
                    <Typography
                        variant="h6"
                        sx={{
                            textTransform: "uppercase",
                            letterSpacing: "0.08em",
                            fontWeight: "bold",
                            color: "#333",
                            fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
                        }}
                    >
                        Fatura Müşterileri
                    </Typography>
                </Box>
            </Box>

            {/* Arama Filtresi */}
            <Box sx={{ 
                mb: 3, 
                display: 'flex', 
                gap: 2, 
                alignItems: 'center',
                flexWrap: 'wrap'
            }}>
                <TextField
                    label="Müşteri Ara"
                    variant="outlined"
                    size="medium"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    onKeyPress={handleSearchKeyPress}
                    placeholder="Müşteri adı ile ara..."
                    sx={{ 
                        minWidth: { xs: '100%', sm: 300 },
                        flexGrow: { xs: 1, sm: 0 }
                    }}
                />
                <Button
                    variant="contained"
                    onClick={handleSearch}
                    startIcon={<SearchIcon />}
                    sx={{ 
                        height: 56,
                        minWidth: 120
                    }}
                >
                    Ara
                </Button>
            </Box>

            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="customer table">
                    <TableHead>
                        <TableRow>
                            <TableCell>İsim</TableCell>
                            <TableCell>E-Mail</TableCell>
                            <TableCell>Kimlik/Vergi No</TableCell>
                            <TableCell>Tip</TableCell>
                            <TableCell align="center">İşlemler</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {customers.map((customer) => (
                            <TableRow
                                key={customer.id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell>{customer.name || '-'}</TableCell>
                                <TableCell>{customer.mail || '-'}</TableCell>
                                <TableCell>{customer.identifier || '-'}</TableCell>
                                <TableCell>{customer.type === 0 ? 'Tüzel Kişi' : 'Gerçek Kişi'}</TableCell>
                                <TableCell align="center">
                                    <IconButton
                                        color="primary"
                                        onClick={() => handleEditClick(customer)}
                                        size="small"
                                    >
                                        <EditIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                <Pagination
                    count={totalPages}
                    page={page}
                    onChange={handlePageChange}
                    color="primary"
                    showFirstButton
                    showLastButton
                />
            </Box>

            {/* Düzenleme Modal */}
            <Modal
                open={modalOpen}
                onClose={handleModalClose}
                aria-labelledby="edit-customer-modal"
                aria-describedby="edit-customer-form"
            >
                <Box sx={modalStyle}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                        <Typography variant="h6" component="h2">
                            Müşteri Düzenle
                        </Typography>
                        <IconButton onClick={handleModalClose}>
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    <Stack spacing={3}>
                        <TextField
                            fullWidth
                            label="İsim"
                            value={editingCustomer.name}
                            onChange={(e) => handleInputChange('name', e.target.value)}
                            variant="outlined"
                        />

                        <TextField
                            fullWidth
                            label="E-Mail"
                            type="email"
                            value={editingCustomer.mail}
                            onChange={(e) => handleInputChange('mail', e.target.value)}
                            variant="outlined"
                        />

                        <TextField
                            fullWidth
                            label="Kimlik/Vergi Numarası"
                            value={editingCustomer.identifier}
                            onChange={(e) => handleInputChange('identifier', e.target.value)}
                            variant="outlined"
                        />

                        <TextField
                            fullWidth
                            label="Vergi Dairesi"
                            value={editingCustomer.taxOffice}
                            onChange={(e) => handleInputChange('taxOffice', e.target.value)}
                            variant="outlined"
                        />

                        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', mt: 3 }}>
                            <Button
                                variant="outlined"
                                onClick={handleModalClose}
                                color="secondary"
                            >
                                İptal
                            </Button>
                            <Button
                                variant="contained"
                                onClick={handleSaveCustomer}
                                color="primary"
                            >
                                Kaydet
                            </Button>
                        </Box>
                    </Stack>
                </Box>
            </Modal>
        </Box>
    );
};

export default InvoiceCustomer;